import { createSelector } from 'reselect';

import { CustomLessonInfoModalStoreState } from 'common.components/custom-lesson-info-modal/typings';

const customLessonInfoModalSelector = (storeState: { customLessonInfoModal: CustomLessonInfoModalStoreState }) =>
    storeState.customLessonInfoModal;

export const getShouldShowModal = createSelector(customLessonInfoModalSelector, (state) => state.shouldShowModal);
